import styled from 'styled-components/macro';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.gray900};
  flex: 1;
  padding-top: 60px;
`;

export const UserCard = styled.div`
  display: flex;
  margin: 24px;
  align-items: center;
`;

export const UserImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border: 2px solid ${({ theme }) => theme.colors.gray0};
  filter: drop-shadow(0px 2px 7px rgba(0, 0, 0, 0.1));
  border-radius: 52px;
  background-color: ${({ theme }) => theme.colors.gray800};

  label {
    font-size: 24px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.primaryGreen500};
    text-transform: uppercase;
    margin-top: -4px;
  }
`;

export const UserContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 16px;
  gap: 8px;
`;

export const FullName = styled.label`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.primaryGreen500};
  text-transform: capitalize;
`;

export const JobDescription = styled.label`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.gray0};
`;

export const MobileNumber = styled.label`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.gray0};
`;

export const StarRate = styled.label`
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.gray0};
  position: fixed;
  right: 24px;
  gap: 2px;

  span {
    font-size: 24px;
  }
`;

export const UserImageSkeleton = styled.div`
  width: 80px;
  height: 80px;
  filter: drop-shadow(0px 2px 7px rgba(0, 0, 0, 0.1));
  border-radius: 52px;
  background-color: ${({ theme }) => theme.colors.gray600};
`;

export const FullNameSkeleton = styled.label`
  height: 18px;
  width: 150px;
  background-color: ${({ theme }) => theme.colors.gray600};
`;

export const MobileNumberSkeleton = styled.label`
  height: 12px;
  width: 100px;
  background-color: ${({ theme }) => theme.colors.gray600};
`;
export const Logout = styled.div`
  padding-inline: 24px;
  width: 100%;
  position: fixed;
  bottom: 100px;
  & > button {
    background-color: transparent;
    color: ${({ theme }) => theme.colors.red500};
  }
`;

export const ErrorBodyWrapper = styled.div`
  padding-top: ${({ theme }) => theme.spacing.xs};

  & > p {
    color: ${({ theme }) => theme.colors.gray0};
  }
`;
export const ErrorButtons = styled.div`
  margin-top: ${({ theme }) => theme.spacing.lg};
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.sm};
`;
export const LogoutText = styled.p``;
